import { Vector3 as n, Quaternion as e } from "three";
const o = new n(), c = new e(), r = new n(), i = (t) => (t.decompose(o, c, r), o.clone());
export {
  i as MatrixToPosition
};
//# sourceMappingURL=index20.js.map
